import { SweetenersPayload } from 'generated/graphql';
import { PAGE_LIMIT, TabEnum, selectTypeInitialValues } from 'constants/index';
import { SelectType } from 'interfaces';

export type State = {
  page: number;
  count: number;
  search: string;
  rowsPerPage: number;
  size: string;
  nature: string;
  productType: SelectType;
  productSize: SelectType;
  subProductType: SelectType;
  productFormulation: SelectType;
  activeTab: TabEnum;
  data: SweetenersPayload['data'];
};

export const initialState: State = {
  page: 1,
  count: 0,
  data: [],
  search: '',
  size: '',
  nature: '',
  productType: selectTypeInitialValues,
  productSize: selectTypeInitialValues,
  subProductType: selectTypeInitialValues,
  productFormulation: selectTypeInitialValues,
  rowsPerPage: PAGE_LIMIT,
  activeTab: TabEnum.Active,
};

export enum ActionType {
  SET_PAGE = 'setPage',
  SET_DATA = 'setData',
  SET_COUNT = 'setCount',
  SET_SEARCH = 'setSearch',
  SET_ACTIVE_TAB = 'setActiveTab',
  SET_SIZE = 'setSize',
  SET_NATURE = 'setNature',
  SET_PRODUCT_TYPE = 'setProductType',
  SET_PRODUCT_SIZE = 'setProductSize',
  SET_PRODUCT_FORMULATION = 'setProductFormulation',
  SET_SUB_PRODUCT_TYPE = 'setSubProductType',
  SET_ROWS_PER_PAGE = 'setRowsPerPage',
}

export type Action =
  | { type: ActionType.SET_PAGE; page: number }
  | { type: ActionType.SET_COUNT; count: number }
  | { type: ActionType.SET_ROWS_PER_PAGE; rowsPerPage: number }
  | { type: ActionType.SET_SEARCH; search: string }
  | { type: ActionType.SET_SIZE; size: string }
  | { type: ActionType.SET_NATURE; nature: string }
  | { type: ActionType.SET_PRODUCT_TYPE; productType: SelectType }
  | { type: ActionType.SET_PRODUCT_SIZE; productSize: SelectType }
  | { type: ActionType.SET_PRODUCT_FORMULATION; productFormulation: SelectType }
  | { type: ActionType.SET_SUB_PRODUCT_TYPE; subProductType: SelectType }
  | { type: ActionType.SET_DATA; data: SweetenersPayload['data'] }
  | { type: ActionType.SET_ACTIVE_TAB; activeTab: TabEnum };

export const sweetenerReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.SET_PAGE:
      return {
        ...state,
        page: action.page,
      };

    case ActionType.SET_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.rowsPerPage,
      };

    case ActionType.SET_COUNT:
      return {
        ...state,
        count: action.count,
      };

    case ActionType.SET_DATA:
      return {
        ...state,
        data: action.data,
      };

    case ActionType.SET_SEARCH:
      return {
        ...state,
        search: action.search,
      };

    case ActionType.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.activeTab,
      };

    case ActionType.SET_SIZE:
      return {
        ...state,
        size: action.size,
      };

    case ActionType.SET_NATURE:
      return {
        ...state,
        nature: action.nature,
      };

    case ActionType.SET_PRODUCT_TYPE:
      return {
        ...state,
        productType: action.productType,
      };

    case ActionType.SET_PRODUCT_SIZE:
      return {
        ...state,
        productSize: action.productSize,
      };

    case ActionType.SET_PRODUCT_FORMULATION:
      return {
        ...state,
        productFormulation: action.productFormulation,
      };

    case ActionType.SET_SUB_PRODUCT_TYPE:
      return {
        ...state,
        subProductType: action.subProductType,
      };
  }
};
